import { HttpBackend, HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { ReplaySubject } from 'rxjs';

import { AutoneumConfiguration } from '../models/configuration';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private httpClient: HttpClient;
  private config!: AutoneumConfiguration;
  public configBroadcast$ = new ReplaySubject<AutoneumConfiguration>(1);

  constructor() {
    const httpBackend = inject(HttpBackend);

    this.httpClient = new HttpClient(httpBackend);
  }

  /**
   * loads the configuration from filelocation
   * @param fileLocation file location of the configuration
   * @returns true if is resolved
   */
  load(fileLocation: string): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.httpClient.get<AutoneumConfiguration>(fileLocation).subscribe((config: AutoneumConfiguration) => {
        this.config = config;
        this.configBroadcast$.next(config);
        resolve(true);
      });
    });
  }

  /**
   * @description get the configuration
   * @returns configuration
   */
  getConfiguration(): AutoneumConfiguration {
    return this.config;
  }
}
